import { UrlBuilderTypes } from "./types";
import { Reducer } from "redux";
import { ContactFormField, UrlBuilderState } from ".";

const initialState: UrlBuilderState = {
  _id: "",
  userId: "",
  cardId: 0,
  info: {
    phoneNumber: "",
    email: "",
    calendar: "",
    location: "",
    website: "",
    links: [],
  },
  aboutMe: { text: "" },
  socialNetworks: [],
  video: {
    file: {
      _id: "0",
      fileName: "",
      filePath: "",
      mimeType: "",
      createdAt: "",
      updatedAt: "",
      __v: 0,
    },
    actionType: null,
    videoUrl: "",
  },
  images: [],
  testimonials: [],
  customCTA: { buttonLink: "", buttonText: "", buttonColor: "" },
  appStores: [],
  contactForm: {
    contactMail: "",
    fields: [
      {
        fieldName: "Full Name",
        fieldType: "Text",
        isRequired: true,
        editable: false,
      },
      {
        fieldName: "Email Adress",
        fieldType: "Email",
        isRequired: true,
        editable: false,
      },
      {
        fieldName: "Company Name",
        fieldType: "Text",
        isRequired: false,
        editable: false,
      },
      {
        fieldName: "Job Title",
        fieldType: "Text",
        isRequired: false,
        editable: false,
      },
      {
        fieldName: "Phone Number",
        fieldType: "Number",
        isRequired: true,
        editable: false,
      },
      {
        fieldName: "Message",
        fieldType: "Textarea",
        isRequired: true,
        editable: false,
      },
    ],
  },
  primaryColor: { color: "#000000" },
  published: { published: false, publishedDate: undefined },
  paymentOptions: [],
  urlDesignType: "PRO",
  permissions: [],
  order: [],
};

const UrlBuilderReducer: Reducer<UrlBuilderState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case UrlBuilderTypes.SET_BUILDER_DATA: {
      if (action.data.contactForm.fields.length === 0)
        action.data.contactForm.fields = state.contactForm.fields;

      //check for company name field, and job title add if it is not exist, and insert it after full name
      let isCompanyName = false;
      let isJobTitle = false;
      let indexOfName = 0;
      action.data.contactForm.fields?.forEach(
        (field: ContactFormField, index: number) => {
          if (field.fieldName === "Company Name") {
            isCompanyName = true;
          }

          if (field.fieldName === "Job Title") {
            isJobTitle = true;
          }

          if (field.fieldName === "Full Name") indexOfName = index;
        }
      );
      if (action?.data?.contactForm?.fields?.length > 0 && !isCompanyName) {
        action.data["contactForm"]["fields"].splice(indexOfName + 1, 0, {
          fieldName: "Company Name",
          fieldType: "Text",
          isRequired: false,
          editable: false,
        });
      }

      if (action?.data?.contactForm?.fields?.length > 0 && !isJobTitle) {
        action.data["contactForm"]["fields"].splice(indexOfName + 2, 0, {
          fieldName: "Job Title",
          fieldType: "Text",
          isRequired: false,
          editable: false,
        });
      }

      return { ...state, ...action.data };
    }
    case UrlBuilderTypes.SET_BUILDER_PUBLISH: {
      return { ...state, published: action.published };
    }
    case UrlBuilderTypes.SET_BUILDER_PERMISSIONS: {
      return { ...state, permissions: action.data };
    }
    case UrlBuilderTypes.UPDATE_BUILDER_PERMISSIONS: {
      const newPermissions = state.permissions.map((p) => {
        if (
          p.objectId === action.data.objectId &&
          p.objectPermission.objectPermissionId ===
            action.data.objectPermission.objectPermissionId
        )
          return action.data;

        return p;
      });
      return { ...state, permissions: newPermissions };
    }
    default:
      return state;
  }
};

export default UrlBuilderReducer;
